module.exports = __webpack_public_path__ + "static/img/cp-right.d16fdc56.png";